import React from "react";
import {
  TextField,
  InputAdornment,
  IconButton,
  Paper,
  Typography,
  Box,
  Chip,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";

const styles = {
  searchField: {
    width: "320px",
    "& .MuiOutlinedInput-root": {
      backgroundColor: "#ffffff",
      borderRadius: "12px",
      transition: "all 0.2s ease",
      "& fieldset": {
        borderColor: "#E5E7EB",
      },
      "&:hover fieldset": {
        borderColor: "#9CA3AF",
        boxShadow: "0 0 0 3px rgba(59, 130, 246, 0.1)",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#3B82F6",
        boxShadow: "0 0 0 3px rgba(59, 130, 246, 0.1)",
      },
    },
  },
  countBadge: {
    px: 2,
    py: 1,
    borderRadius: "12px",
    backgroundColor: "#F3F4F6",
    border: "1px solid #E5E7EB",
  },
};

/**
 * Search bar with count badge and optional filter indicator
 * @param {String} value - Search query value
 * @param {Function} onChange - Change handler
 * @param {String} placeholder - Placeholder text
 * @param {Number} count - Number of items found
 * @param {String} countLabel - Label for count (e.g., "items found")
 */
const SearchBar = ({
  value,
  onChange,
  placeholder = "Search...",
  count = undefined,
  countLabel = undefined,
}) => {
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 2, width: "100%" }}>
      {/* Search Field */}
      <TextField
        size="small"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        sx={styles.searchField}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon sx={{ color: "#6B7280", fontSize: 20 }} />
            </InputAdornment>
          ),
          endAdornment: value && (
            <InputAdornment position="end">
              <IconButton
                size="small"
                onClick={() => onChange({ target: { value: "" } })}
                sx={{ color: "#6B7280" }}
              >
                <ClearIcon fontSize="small" />
              </IconButton>
            </InputAdornment>
          ),
        }}
      />

      {/* Count Badge */}
      {countLabel && (
        <Paper elevation={0} sx={styles.countBadge}>
          <Typography variant="body2" color="#374151" fontWeight="500">
            {count} {countLabel}
          </Typography>
        </Paper>
      )}
    </Box>
  );
};

export default SearchBar;
